export const Brand = ({ footer = false }) => (
  <a href="#inizio" className={`brand ${footer ? 'brand-footer' : ''}`} aria-label="Composite Research — torna all’inizio" data-testid={footer ? 'footer-brand-link' : 'header-brand-link'}>
    <img className="official-logo" src="/assets/composite-research-logo.webp" alt="Logo CoRe — Composite Research" width="1600" height="479" data-testid={footer ? 'footer-official-logo' : 'header-official-logo'} />
    <span className="brand-name">COMPOSITE<br />RESEARCH</span>
  </a>
);

export const BrandMark = ({ className = '' }) => (
  <img className={`brand-symbol ${className}`} src="/assets/composite-research-mark.png" alt="" aria-hidden="true" width="386" height="403" />
);